import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UsuarioService } from '../../../services/usuario.service';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-cancelar-pedido',
  templateUrl: './alterar-forma-pagamento-dialog.html',
  styleUrls: ['./alterar-forma-pagamento-dialog.scss', '../../../styles/estilo.padrao.scss']
})

export class AlterarFormaPagamentoDialog implements OnInit {
  uid;
  formaPagamentoForm: FormGroup;
  sStringMinimoBoleto: string | null = null;

  aFormaPagamento: any[] = [
    { value: 'Cheque', name: 'Cheque' },
    { value: 'Cartão de crédito', name: 'Cartão de crédito' },
    { value: 'Cartão de débito', name: 'Cartão de débito' },
    { value: 'Dinheiro', name: 'Dinheiro' },
    { value: 'Nota', name: 'Nota' },
    { value: 'Pix', name: 'Pix' },
  ];

  aBandeirasCartao: any[] = [
    { value: 'MasterCard', name: 'MasterCard' },
    { value: 'Visa', name: 'Visa' },
    { value: 'Elo', name: 'Elo' },
    { value: 'AmericanExpress', name: 'AmericanExpress' },
  ];

  aPrazoBoletos: any[] = [
    { value: 10, name: '10 dias' },
    { value: 15, name: '15 dias' },
  ];

  aNumeroParcelas: any[] = [
    { value: 1, name: '1 boleto' },
    { value: 2, name: '2 boletos' },
  ];

  aPrazoNota: any[] = [
    { value: 1, name: '1 dia' },
    { value: 2, name: '2 dias' },
    { value: 3, name: '3 dias' },
    { value: 4, name: '4 dias' },
    { value: 5, name: '5 dias' },
    { value: 6, name: '6 dias' },
    { value: 7, name: '7 dias' },
    { value: 8, name: '8 dias' },
    { value: 9, name: '9 dias' },
    { value: 10, name: '10 dias' },
    { value: 11, name: '11 dias' },
    { value: 12, name: '12 dias' },
    { value: 13, name: '13 dias' },
    { value: 14, name: '14 dias' },
    { value: 15, name: '15 dias' },
    { value: 16, name: '16 dias' },
    { value: 17, name: '17 dias' },
    { value: 18, name: '18 dias' },
    { value: 19, name: '19 dias' },
    { value: 20, name: '20 dias' },
    { value: 21, name: '21 dias' },
    { value: 22, name: '22 dias' },
    { value: 23, name: '23 dias' },
    { value: 24, name: '24 dias' },
    { value: 25, name: '25 dias' },
    { value: 26, name: '26 dias' },
    { value: 27, name: '27 dias' },
    { value: 28, name: '28 dias' },
    { value: 29, name: '29 dias' },
    { value: 30, name: '30 dias' },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<AlterarFormaPagamentoDialog>,
    private usuarioService: UsuarioService,
    @Inject(MAT_DIALOG_DATA) public data: { formaPagamento: string, bandeiraCartao: string, numeroParcelas: number, prazoBoleto: number, prazoNota: number, total: number }
  ) {
    this.uid = localStorage.getItem('uid');

    this.usuarioService.getValoresMinimos().pipe(take(1)).subscribe(snap => {
      const dados: any = snap.payload.val();
      if (dados) {

        if (data.total >= dados.Boleto)
          this.aFormaPagamento.unshift({ value: 'Boleto', name: 'Boleto' });
        else
          this.sStringMinimoBoleto = `O valor mínimo do pedido deve ser de ${dados.Boleto.toFixed(2)} para a forma de pagamento boleto.`;
      }
    });
  }

  ngOnInit(): void {
    this.formaPagamentoForm = this.formBuilder.group({
      formaPagamento: [this.data.formaPagamento, [Validators.required]],
      bandeiraCartao: [this.data.bandeiraCartao, null],
      numeroParcelas: [this.data.numeroParcelas, null],
      prazoBoleto: [this.data.prazoBoleto, null],
      prazoNota: [this.data.prazoNota, null],
    });
  }

  confirmarAlteracaoFormaPagamento() {
    if (this.formaPagamentoForm.valid) {
      this.dialogRef.close({ FormaPagamento: this.f.formaPagamento.value, BandeiraCartao: this.f.bandeiraCartao.value, NumeroParcelas: this.f.numeroParcelas.value, PrazoBoleto: this.f.prazoBoleto.value, PrazoNota: this.f.prazoNota.value });

    } else {
      this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      this.formaPagamentoForm.markAllAsTouched();
    }
  }

  cancelar() {
    this.dialogRef.close();
  }

  // convenience getter for easy access to form fields
  get f() { return this.formaPagamentoForm.controls; }

}
